const pileStatus: {
  [key in 'standby' | 'charging' | 'waiting' | 'noSignal']: {
    text: string;
  };
} = {
  standby: {
    text: '待機中',
  },
  charging: {
    text: '充電中',
  },
  waiting: {
    text: '排隊中',
  },
  noSignal: {
    text: '無訊號',
  },
};

export { pileStatus };
